import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function PathoRiskNoStarsText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Watchlist of" 
            headline_grey = "Genetic Variants"
            headline_p2 = "with Limited Evidence"

            text1 = "These genetic variants are listed because they were found in your genome. However, there is currently not enough research or evidence to classify them with high certainty."
            text2 = "While these variants may not be fully understood yet, they could be important in the future if health issues arise. It’s useful for doctors to be aware of them, as new research could reveal their significance."
            text3 = "Additionally, sharing this information may contribute to medical genetic research, potentially helping others in the future."
            />
    }/>
            
  )
}